import React, { memo, useMemo } from 'react';
import Chart from "./Chart";
import Map from "./Map";
import Kpi from "./Kpi";
import Table from "./Table";
import Empty from "../Widget/Empty";
import { CHART_TYPES, NOT_CHART_TYPES } from "../../constants";
var _ref2 = /*#__PURE__*/React.createElement(Empty, {
  type: "empty"
});
var _ref4 = /*#__PURE__*/React.createElement(Empty, {
  type: "empty"
});
var _ref6 = /*#__PURE__*/React.createElement(Empty, {
  type: "empty"
});
var _ref8 = /*#__PURE__*/React.createElement(Empty, {
  type: "empty"
});
const Charts = /*#__PURE__*/memo(_ref => {
  let {
    chartType,
    config,
    getImage,
    googleMapsApiKey,
    isExpanded
  } = _ref;
  var _ref3 = /*#__PURE__*/React.createElement(Map, {
    data: config,
    googleMapsApiKey: googleMapsApiKey,
    getImage: getImage
  });
  var _ref5 = /*#__PURE__*/React.createElement(Kpi, {
    data: config,
    getImage: getImage
  });
  var _ref7 = /*#__PURE__*/React.createElement(Table, {
    data: config,
    getImage: getImage,
    isExpanded: isExpanded
  });
  var _ref9 = /*#__PURE__*/React.createElement(Chart, {
    type: chartType,
    data: config,
    getImage: getImage
  });
  const renderChart = useMemo(() => {
    var _config$data, _config$data2, _config$datasets;
    if (!chartType) return null;
    switch (chartType) {
      case NOT_CHART_TYPES.map:
        if (!(config !== null && config !== void 0 && config.length)) {
          return _ref2;
        }
        return _ref3;
      case NOT_CHART_TYPES.kpi:
        if (!(config !== null && config !== void 0 && (_config$data = config.data) !== null && _config$data !== void 0 && _config$data.length)) {
          return _ref4;
        }
        return _ref5;
      case NOT_CHART_TYPES.table:
        if (!(config !== null && config !== void 0 && (_config$data2 = config.data) !== null && _config$data2 !== void 0 && _config$data2.length)) {
          return _ref6;
        }
        return _ref7;
      case CHART_TYPES.bar:
      default:
        if (!(config !== null && config !== void 0 && (_config$datasets = config.datasets) !== null && _config$datasets !== void 0 && _config$datasets.length)) {
          return _ref8;
        }
        return _ref9;
    }
  }, [chartType, config, googleMapsApiKey, getImage, isExpanded]);
  return renderChart;
});
export default Charts;